<template>
    <div class="container">
        <!-- 标题区域 -->
        <div class="header">
            <h1 class="title">{{ collectDetail.chatTitle || '收藏详情' }}</h1>
            <div class="meta">
                <span>{{ collectDetail.createtime || '' }}</span>
            </div>
        </div>
        <div class="chat-container">
            <template v-if="collectDetail && collectDetail.aiUserChatMsgList">
                <div v-for="(item, index) in collectDetail.aiUserChatMsgList" :key="index" class="chat-item">
                    <!-- 问题（居右 + 换行对齐） -->
                    <div class="chat-question">
                        <div class="tag">{{ item.yuamrQuestion }}</div>
                    </div>

                    <!-- 内容（居左 + 最大宽度 + 链接/英文换行） -->
                    <div class="chat-answer">
                        <div class="content-section" v-html="item.yuamrAnswer"></div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { getAiUserChatCollectionDetails } from "../../api/api";
export default {
    name: 'VariableNamePage',
    data() {
        return {
            tableData: [],
            formDatas: {
                currentPage: 1,
                pageSize: 15,
            },
            totalCount: 10,
            // 编辑模式开关
            isEdit: false,
            // 收藏列表数据（匹配截图中的内容）
            collectDetail: [

            ]
        };
    },
    created() {
        this.theId = this.$route.query.id ? this.$route.query.id : '';
        if (this.theId) {
            // 这里可以添加根据ID获取收藏详情的逻辑
            getAiUserChatCollectionDetails({ auccId: this.theId }).then(res => {
                if (res.status == 200) {
                    this.collectDetail = res.data;
                    window.document.title = this.collectDetail.chatTitle + ' - 收藏详情';
                }
            })
        }
    },
    mounted() {

    },
    methods: {

    }
}
</script>

<style scoped>
/* 全局容器样式 */
.container {
    max-width: 800px;
    margin: 20px auto;
    padding: 0 20px;
    font-family: "Microsoft Yahei", sans-serif;
    color: #333;
}

/* 标题区域 */
.header .title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 8px;
}

.header .meta {
    font-size: 12px;
    color: #999;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
}

/* 标签样式 */
.tag {
    padding: 4px 10px;
    background: #f5f5f5;
    border-radius: 4px;
    font-size: 14px;
    color: #666;
    margin-bottom: 20px;
}

/* 内容区域通用样式 */
.content-section {
    margin-bottom: 30px;
}

.desc {
    font-size: 16px;
    margin-bottom: 10px;
}

.var-list {
    list-style: disc;
    padding-left: 20px;
    margin-bottom: 15px;
    font-size: 15px;
}

.var-list code {
    background: #f0f0f0;
    padding: 2px 4px;
    border-radius: 2px;
    font-family: "Consolas", monospace;
}

.note {
    font-size: 14px;
    color: #666;
    line-height: 1.6;
}

/* 关联变量区域 */
.related-section {
    margin-top: 30px;
}

.related-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 15px;
}

.related-list {
    list-style: decimal;
    padding-left: 20px;
    font-size: 15px;
}

.related-list li {
    margin-bottom: 8px;
}

.related-list code {
    background: #f0f0f0;
    padding: 2px 4px;
    border-radius: 2px;
    font-family: "Consolas", monospace;
}

.chat-container {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px 10px;
    font-family: "Microsoft Yahei", sans-serif;
    color: #333;
}

/* 单条对话项 */
.chat-item {
    margin-bottom: 30px;
}

/* 问题区域：居右 + 换行后文本右对齐 */
.chat-question {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 15px;
}

.chat-question .tag {
    display: inline-block;
    padding: 6px 12px;
    background: #f5f5f5;
    border-radius: 4px;
    font-size: 14px;
    color: #666;
    max-width: 70%;
    text-align: left;
    /* 换行后内容右对齐 */
    word-wrap: break-word;
    /* 强制换行 */
}

/* 回答区域：居左 + 内容最大宽度 */
.chat-answer {
    display: flex;
    justify-content: flex-start;
}

.content-section {
    max-width: 800px;
    width: 100%;
    line-height: 30px;
    font-size: 15px;
    /* 解决链接/英文超出宽度问题 */
    word-wrap: break-word;
    /* 强制换行 */
    word-break: break-all;
    /* 英文/数字强制换行 */
}

/* 适配v-html里的内容样式 */
.content-section p {
    margin: 10px 0;
}

.content-section ul,
.content-section ol {
    padding-left: 20px;
    margin: 10px 0;
    /* 列表项内换行对齐 */
    list-style-position: outside;
}

.content-section code {
    background: #f0f0f0;
    padding: 2px 4px;
    border-radius: 2px;
    font-family: "Consolas", monospace;
}

.content-section a {
    color: #0066cc;
    text-decoration: underline;
    /* 链接强制换行 */
    word-break: break-all;
}
</style>